var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import { RadioButtonDesignStyles, RadioButtonSizes, RadioButtonStates } from '../../../../atoms/radio-button';
import { Text, TextHorizontalAlignments, TextHtmlTags, TextVariants } from '../../../../atoms/text';
import { RadioGroup, RadioGroupOrientations } from '../../../../molecules/radio-group';
import { Container, ContainerDisplays, ContainerFlexDirections, ContainerFlexGaps } from '../../../../templates/container';
import { StockStatuses } from '../stock-info/types';
import { getColumnWidthWithGap } from '../../../../../utils';
var CONTAINER_CONFIG = {
    display: ContainerDisplays.Flex,
    flexDirection: ContainerFlexDirections.Column,
    flexGap: ContainerFlexGaps.Size_2
};
var VARIANT_OPTION_TEXT_CONFIG = {
    variant: TextVariants.Body2,
    isHtml: true,
    component: TextHtmlTags.Span,
    horizontalAlignment: TextHorizontalAlignments.Center
};
var AS = function (_a) {
    var _b;
    var currentValue = _a.currentValue, name = _a.name, label = _a.label, attributeVariants = _a.attributeVariants, onAttributeChange = _a.onAttributeChange;
    var sortedVariants = useMemo(function () {
        return attributeVariants === null || attributeVariants === void 0 ? void 0 : attributeVariants.slice().sort(function (a, b) {
            if (a.stock === StockStatuses.OutOfStock) {
                return 1;
            }
            if (b.stock === StockStatuses.OutOfStock) {
                return -1;
            }
            return 0;
        });
    }, [attributeVariants]);
    var currentVariant = useMemo(function () { return sortedVariants === null || sortedVariants === void 0 ? void 0 : sortedVariants.find(function (variant) { return variant.value === currentValue; }); }, [currentValue, sortedVariants]);
    var labelConfig = {
        content: label,
        variant: TextVariants.Body3
    };
    var varionOptionExtraTextConfig = {
        content: currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.puffsNo,
        variant: TextVariants.Body3,
        component: TextHtmlTags.Span
    };
    var elements = (_b = sortedVariants === null || sortedVariants === void 0 ? void 0 : sortedVariants.length) !== null && _b !== void 0 ? _b : 0;
    var splits = elements <= 4 ? elements : 4;
    var itemWidth = getColumnWidthWithGap(1, splits, ContainerFlexGaps.Size_2);
    var radioButtonsConfig = useMemo(function () {
        var _a;
        return (_a = sortedVariants === null || sortedVariants === void 0 ? void 0 : sortedVariants.map(function (variant) { return ({
            size: RadioButtonSizes.Size_5,
            icon: (React.createElement(Text, __assign({}, VARIANT_OPTION_TEXT_CONFIG, { content: variant.attributeLabel }))),
            checkedIcon: (React.createElement(Text, __assign({}, VARIANT_OPTION_TEXT_CONFIG, { content: variant.attributeLabel }))),
            onChange: function (e) {
                onAttributeChange === null || onAttributeChange === void 0 ? void 0 : onAttributeChange(e, variant);
            },
            checked: variant.attributeLabel === (currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.attributeLabel),
            designStyle: RadioButtonDesignStyles.Squared,
            value: variant.value,
            state: variant.stock === StockStatuses.OutOfStock
                ? RadioButtonStates.Disabled
                : RadioButtonStates.Default,
            'aria-label': variant.attributeLabel,
            width: itemWidth
        }); })) !== null && _a !== void 0 ? _a : [];
    }, [
        currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.attributeLabel,
        itemWidth,
        onAttributeChange,
        sortedVariants
    ]);
    var radioGroupConfig = {
        name: name,
        value: currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.attributeLabel,
        radioButtons: radioButtonsConfig,
        designStyle: RadioButtonDesignStyles.Squared,
        row: RadioGroupOrientations.Horizontal,
        'aria-label': (currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.attributeLabel) || name
    };
    return (React.createElement(Container, __assign({}, CONTAINER_CONFIG),
        label && sortedVariants && (sortedVariants === null || sortedVariants === void 0 ? void 0 : sortedVariants.length) > 0 && (React.createElement(React.Fragment, null,
            React.createElement(Text, __assign({}, labelConfig)),
            React.createElement(RadioGroup, __assign({}, radioGroupConfig)))),
        (currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.puffsNo) && React.createElement(Text, __assign({}, varionOptionExtraTextConfig))));
};
export { AS as AttributeSelector };
